import(/* webpackMode: "eager", webpackExports: ["ForgotForm"] */ "/home/runner/work/agentx/agentx/apps/web/app/login/forgot/ForgotForm.tsx");
